// GET Requests

// export const USERS_EMAIL_AVAILABLE = '/users/email-available';
// export const USERS_MANAGER_FETCH = '/users/self';

export const PRODUCT_DIAMONDS = '/api/dd2diamond';
export const PRODUCT_DIAMOND_BY_ID = '/api/diamond/find_by_id';

export const PRODUCT_SETTINGS = '/api/products/gallery';
export const PRODUCT_SETTING_BY_SKU = '/api/products/sku';
export const PRODUCT_SEARCH = '/api/products/search';


// POST Requests
export const API_CONTACT = '/gifts/dd-contact';
export const API_FOUNDATION = '/gifts/foundation';
export const API_SHOPPING = '/gifts/appointment/shopping';
export const API_SERVICE = '/gifts/appointment/service';
export const API_SUMMER_CONTACT = '/gifts/summer-contact';
export const API_AUBURN_CONTACT = '/gifts/auburn-contact';
export const API_WATCH = '/gifts/watch';
export const API_CUSTOM_DESIGN = '/gifts/custom-design';

// export const USERS_FORGOT_PASSWORD = '/users/forgot-password';
// export const USERS_LOGIN = '/users/login';
// export const USERS_RESET_PASSWORD = '/users/reset-password';



// Orders endpoints
export const ORDERS_GET_EXTERNAL = '/api/orders/external';


// Wishlist endpoints (Legacy)
export const WISHLISTS_GET = '/api/wishlists/all';
export const WISHLISTS_CREATE = '/api/wishlists/create';
export const WISHLISTS_EDIT = '/api/wishlists/edit';
export const WISHLISTS_DELETE = '/api/wishlists/delete';
export const WISHLIST_ITEM_ADD = '/api/wishlists/add';
export const WISHLIST_ITEM_REMOVE = '/api/wishlists/remove';

// Wishlists endpoits V2
export const WISHLISTS_V2 = '/api/wishlists/';
// export const WISHLISTS2 = '/api/wishlists';
// export const WISHLISTS2 = '/api/wishlists';




// Magento Requests

// GET Requests
export const MAGENTO_GET_USER = '/customers/me';
export const MAGENTO_GET_ORDERS = '/ddorder/fetch';
export const MAGENTO_CHECK_HK_STATUS = '/diamondsdirect-diamondorder/check-kh'

// POST Requests
export const MAGENTO_GET_GUEST_CART = '/guest-carts';
export const MAGENTO_ADD_TO_CART = '/ddcart/add';
export const MAGENTO_ADD_METAL_SIZE = '/ddcart/add-ms';
export const MAGENTO_ADD_ENGAGEMENT = '/ddcart/engagement';
export const MAGENTO_ADD_DIAMOND = '/ddcart/diamond';

export const MAGENTO_ADD_DIAMOND_JEWELRY = '/ddcart/diamond-jewelry';

export const MAGENTO_LOGIN = '/integration/customer/token';
export const MAGENTO_REGISTER = '/customers';
export const MAGENTO_LOGGED_IN_CART = '/carts/mine';

// PUT Requests
export const MAGENTO_FORGOT_PASSWORD = '/customers/password';
export const MAGENTO_SET_PASSWORD = '/customers/me/password';

// Magento Module Request
export const MAGENTO_CART_COUNT = '/ddcart/mine';



// User Requests

export const USER_SERVICE_PROFILE = '/api/customers/me';




// Third party requests (full URLS)

export const INSTAGRAM_GET_IMAGES = 'https://www.instagram.com/diamondsdirect/?__a=1';







// WEBPACK FOOTER //
// ./src/constants/endpoints.jsx